import { useEffect } from 'react'

export function Head({ title }) {
  useEffect(() => {
    const baseTitle = 'mld.gg'
    document.title = title ? `${title} | ${baseTitle}` : baseTitle
  }, [title])

  return null
}
